import { WorkspacesCarousel } from "./WorkspacesCarousel";
import { WorkspacesFilters } from "./WorkspacesFilters";
import { WorkspacesList } from "./WorkspacesList";
import { WorkspacesMap } from "./WorkspacesMap";

type WorkspacesCompound = {
  Filters: typeof WorkspacesFilters;
  List: typeof WorkspacesList;
  Carousel: typeof WorkspacesCarousel;
  Map: typeof WorkspacesMap;
};

/** The workspaces tab's parts. Each renders nothing on other tabs. */
export const Workspaces: WorkspacesCompound = {
  Filters: WorkspacesFilters,
  List: WorkspacesList,
  Carousel: WorkspacesCarousel,
  Map: WorkspacesMap,
};
